function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 1,
  width: 22,
  height: 22,
  rx: 1,
  fill: "#A8FFF8"
});
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 21.5,
  r: 4.5,
  fill: "#CBFF88"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 6.5a.5.5 0 01.5-.5h22a.5.5 0 01.5.5V23a.5.5 0 01-.146.354l-5.5 5.5A.5.5 0 0118 29H1.5a.5.5 0 01-.5-.5v-22zM2 7v21h15.793L23 22.793V7H2z",
  fill: "#14454C"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2 20h21v3h-5v5H2v-8z",
  fill: "#14454C",
  fillOpacity: 0.15
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5 14c0-2 1.5-3 3-3s3 1 3 3-1 3-4 3v3M7 23v1M15.5 11.5h5M15.5 15.5h5M12.5 19.5h8",
  stroke: "#14454C",
  strokeLinecap: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5 23.5v3.793l3.793-3.793H18.5zm-1-.5a.5.5 0 01.5-.5h5.5a.5.5 0 01.354.854l-5.5 5.5a.5.5 0 01-.854-.354V23z",
  fill: "#14454C"
});
function SvgAiQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
export default __webpack_public_path__ + "fonts/ai-quiz-12283e86ce240fc56792712f5cf76e44.svg";
export { SvgAiQuiz as ReactComponent };